import React, {FC, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {useAppDispatch, useAppSelector} from '../../common/hook';
import {setEditAC} from "../../app/popups-reducer";
import TextArea from "antd/es/input/TextArea";
import {useParams} from "react-router-dom";
import {fetchNote} from "../../features/model/service/groups/groups-lessons/fetch-note/fetchNote";
import {fetchLessonsId} from "../../features/model/service/groups/lessons/fetchLessonsId";
import {updateNoteInStore} from "../../features/model/slice/groups/set-lessons/set-note/setNote";


export const FormNote: FC = () => {
    const dispatch = useAppDispatch();
    const [isFilled, setIsFilled] = useState<boolean>(false);
    const { lessonsId } = useParams();
    const lessons = useAppSelector((state) => state.lessons.items);
    const firstLessonNote = lessons.length > 0 ? lessons[0].note : '';
    const [noteValue, setNoteValue] = useState<string>(firstLessonNote);

    const handleFocus = () => {
            setIsFilled(true);
    };

    const handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>) => {
        const { value } = event.target;
        setIsFilled(value !== '');
    };

    const handleNoteChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { value } = event.target;
        setNoteValue(value);
    };

    const onClickHandler = () => {
        dispatch(setEditAC(false));
    };

    const handleSubmit = () => {
        dispatch(fetchNote({ note: noteValue, lessonsId: lessonsId }))
            .then(() => {
                return dispatch(fetchLessonsId(lessonsId));
            })
            .then(() => {
                onClickHandler();
            })
            .catch((error) => {
                // Handle any errors
            });
    };

    return (
        <Formik
            initialValues={{
                note: noteValue,
            }}
            enableReinitialize={true}
            onSubmit={handleSubmit}
        >
            {({ handleSubmit }) => (
                <>
                    <p className="h3 popup-title">Заметка</p>
                    <Form
                        id="note-popup"
                        className="form"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className={`field ${noteValue ? 'filled' : ''}`}>
                            <label className={`field-name ${noteValue ? 'filled' : ''}`}>
                                Текст заметки
                            </label>
                            <div className="textarea-box">
                                <TextArea
                                    className="form-control"
                                    name="note"
                                    id="note"
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    onChange={handleNoteChange}
                                    value={noteValue}
                                    autoSize={{ minRows: 3, maxRows: 10 }}
                                />
                            </div>
                        </div>
                        <button type="submit" className="btn full-width">
                            <span>Сохранить изменения</span>
                        </button>
                    </Form>
                    <span onClick={onClickHandler} className="js-close-popup">
                        <CloseIcon />
                    </span>
                </>
            )}
        </Formik>
    );
};